<div class="pm-form">
  <form (ngSubmit)="sendPm()" novalidate [formGroup]="pmForm">
    <div class="required">Required *</div>
    <div>
      <mat-form-field fxFlex="90%">
        <mat-select placeholder="Send To*" formControlName="toUserID">
          <!-- TODO : Add multiteacher support here -->
          @for (course of courses; track course) {
            <mat-option
              [value]="course.primaryTeacher.userGUID"
              >
              {{ course.primaryTeacher.firstName }}
              {{ course.primaryTeacher.lastName }} -
              {{ course.courseTitle }}
            </mat-option>
          }
        </mat-select>
        <mat-error
          print-error
          [control]="pmForm?.get('toUserID')"
          fieldName="Select a recipient"
          >
        </mat-error>
      </mat-form-field>
    </div>

    <div>
      <mat-form-field class="new-pm__title" fxFlex="90%">
        <label>
          <input
            matInput
            trimInput
            type="text"
            placeholder="Title*"
            formControlName="title"
            />
        </label>
        <mat-error
          print-error
          [control]="pmForm?.get('title')"
          fieldName="Title"
          >
        </mat-error>
      </mat-form-field>
    </div>

    <div>
      <div class="quill-body" fxFlex="90%">
        <quill-editor
          placeholder="Message Body *"
          [modules]="modules"
          [required]="true"
          [modules]="modules"
          formControlName="body"
          (onContentChanged)="setBody($event)"
        ></quill-editor>
        <mat-error
          print-error
          [control]="pmForm?.get('body')"
          fieldName="Message Body"
          >
        </mat-error>
      </div>
    </div>

    <mat-action-row>
      <div fxLayout="row" fxLayoutAlign="end" fxFill fxFlex="100">
        <button
          mat-raised-button
          color="primary"
          class="wide-button"
          type="submit"
          [disabled]="pmForm?.invalid || working"
          >
          <mat-icon aria-label="Send">send</mat-icon>
        </button>
      </div>
    </mat-action-row>
  </form>
</div>
